// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Yt93j","image":"styles_image__Yoao8","video":"styles_video__erQaT","background":"styles_background__+H9FA"};